import React from 'react';
import PropTypes from 'prop-types';

const ResetLayers = props => (
  <div className="ResetLayers">
    <button title="Clear all selected layers" onClick={props.handleClick}>
      <span className="icon icon-reset" />
    </button>
  </div>
);

ResetLayers.propTypes = {
  handleClick: PropTypes.func.isRequired,
};

export default ResetLayers;



// WEBPACK FOOTER //
// ./src/components/ResetLayers.jsx